import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    facilities: FacilityData[];
    isLoading: boolean;
}

type FacilityData = {
    FacilityId: number;
    Name: string;
    Phone: string;
    AcceptingApplications: boolean;
}

class Facilities extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            facilities: [],
            isLoading: false
        }
    }

    public componentWillMount() {
        this.requestFacilities();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Facilites" />
            <div className="row">
                <div className="col">
                    <h1>Facilities</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={ '/facility/0' }
                    >
                        Add Facility
                    </Link>
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            { this.renderFacilitiesTable() }
        </React.Fragment>;
    }

    private renderFacilitiesTable() {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Accepting Applications</th>
                </tr>
            </thead>
            <tbody>
                {this.state.facilities.map((facility, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/facility/${ facility.FacilityId }` }>
                                {facility.Name}
                            </Link>
                        </td>
                        <td>{facility.Phone}</td>
                        <td>{facility.AcceptingApplications ? 'Yes' : 'No'}</td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private requestFacilities() {
        this.setState({ isLoading: true });
        fetchApi(`api/Facilities/List`)
            .then((facilities: FacilityData[]) => {
                this.setState({ facilities, isLoading: false });
            });
    }
}

export default Facilities;
